import 'react-toastify/dist/ReactToastify.css';

import React from 'react';
import type { ToastPosition } from 'react-toastify';
import { toast, ToastContainer } from 'react-toastify';

const ToastrNotif: React.FC = () => <ToastContainer />;

export const showToast = (
  type: 'info' | 'success' | 'warning' | 'error' | 'default',
  message: string,
  autoClose: number = 5000,
  position: ToastPosition = 'top-right',
) => {
  const options = { autoClose, position };

  switch (type) {
  case 'info':
    toast.info(message, options);
    break;
  case 'success':
    toast.success(message, options);
    break;
  case 'warning':
    toast.warning(message, options);
    break;
  case 'error':
    toast.error(message, options);
    break;
  default:
    toast(message, options);
    break;
  }
};

export default ToastrNotif;
